const canUseCSS = typeof CSS !== 'undefined' && typeof CSS.supports === 'function'

export const DVH = canUseCSS && CSS.supports('height: 100dvh') ? 'dvh' : 'vh'
export const DVW = canUseCSS && CSS.supports('width: 100dvw') ? 'dvw' : 'vw'
